// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".launch-btn[data-v-1d81e2c0] {\n  min-width: 48px !important;\n  font-size: 24px;\n  font-weight: 500;\n  letter-spacing: normal;\n}\n.launch-btn .v-btn__content > span[data-v-1d81e2c0] {\n  font-size: 23px;\n}", ""]);
// Exports
module.exports = exports;
